import React from "react";
import { Slide } from "@material-ui/core";
import { pageTop } from "../model/DataConst";
import anime from "animejs";
import styled from "styled-components";

const PageTopDiv = styled.div`
	width: 10vmin;
	height: 10vmin;
	position: fixed;
	right: 2vmin;
	bottom: 2vmin;
	opacity: 0.6;
	border-radius: 50%;
	background-color: #df003a;
  
	&.bottom {
		transform: translateY(-12vh) !important;
	}

	a {
		position: relative;
		display: block;
		width: 10vmin;
		height: 10vmin;
		text-decoration: none;
	}
`;

const onClickPageTop = () => {
	anime.remove( "html, body" );
	anime( {
		targets: "html, body",
		scrollTop: 0,
		dulation: 600,
		easing: 'easeOutCubic',
	} );
};

const PageTop: React.FC = () => {

	const [displaying, changeDisplay] = React.useState( false );

	const [bottomStyle, setBottomStyle] = React.useState( "" );

	// 初回のみ実行
	React.useEffect( () => {
		let timer: any = null;
		const func = () => {
			if ( timer !== null ) {
				clearTimeout( timer );
			}
			timer = setTimeout( function () {
				const hide = window.scrollY < window.innerHeight * 2;
				changeDisplay( !hide );

				try {
					if ( window.scrollY - (document.scrollingElement!.scrollHeight - window.innerHeight - window.innerHeight * 0.1) <= 0 ) {
						setBottomStyle( "" );
						return;
					}

					setBottomStyle( "bottom" );

				} catch ( e ) {
					setBottomStyle( "" );
				}
			}, 200 );
		};
		window.addEventListener( "scroll", func );

		return function cleanup() {
			window.removeEventListener( "scroll", func );
		};
	}, [] );

	return <Slide direction="up" in={displaying} mountOnEnter unmountOnExit>
		<PageTopDiv className={bottomStyle}>
			<a href="#" onClick={onClickPageTop}>
				<img
					style={{
						padding: "10%",
						objectFit: "contain",
						width: "80%",
						height: "80%",
					}}
					src={pageTop}
					alt={"PageTop"}/>
			</a>
		</PageTopDiv>
	</Slide>;
};

export default PageTop;